// usePayoutLimits — per-merchant configurable payout limits.
//
// 60s staleTime — limits change rarely (admin tunes per merchant);
// no background refetch needed.
import { useQuery } from "@tanstack/react-query";

import { listPayoutLimits, type PayoutLimits } from "@/api/payoutLimits";

export function usePayoutLimits(merchantId: number | null | undefined) {
  return useQuery<PayoutLimits[]>({
    queryKey: ["payout-limits", merchantId],
    queryFn: () => listPayoutLimits(merchantId!),
    enabled: merchantId != null && merchantId > 0,
    staleTime: 60_000,
  });
}
